import { useEffect } from 'react'
import { toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	useEffect(() => {
		if (!toast) return

		const id = setTimeout(() => {
			const toastOptions: any = {
				id: toast.id,
				description: toast.description,
			}

			if (toast.duration) {
				toastOptions.duration = toast.duration
			}

			if (toast.action) {
				toastOptions.action = {
					label: toast.action.label,
					onClick: () => {
						window.location.href = toast.action!.onClick
					},
				}
			}

			showToast[toast.type](toast.title, toastOptions)
		}, 0)

		return () => clearTimeout(id)
	}, [toast])
}
